import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../utils/propUtils';
import VeltCommentDialogStatusDropdownContentItemWireframe from './VeltCommentDialogStatusDropdownContentItemWireframe/VeltCommentDialogStatusDropdownContentItemWireframe';
;
var VeltCommentDialogStatusDropdownContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-status-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogStatusDropdownContentWireframe.Item = VeltCommentDialogStatusDropdownContentItemWireframe;
export default VeltCommentDialogStatusDropdownContentWireframe;
